import React from "react";
import Editor from "react-simple-code-editor";
import {Box} from "@mui/material";
import {grey} from "@mui/material/colors";
import {highlightYaml} from "./yamlHighlight";
import {MONOSPACE_FONT, TOKEN_COLORS_SX} from "./dlvStyles";

const VISUALLY_HIDDEN_SX = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};

/**
 * Text editor with syntax highlighting: the highlighted text is drawn behind a transparent textarea.
 * Tab indents; Esc then Tab leaves the editor.
 */
export function DlvCodeEditor({id, label, value, onChange, onKeyDown, error, placeholder, highlight, minHeight, maxHeight, padding = 16, disabled}) {
    return (
        <Box
            data-editor-scroll
            sx={{
                position: 'relative',
                border: 1,
                borderColor: error ? 'error.main' : 'divider',
                borderRadius: 1,
                bgcolor: grey[50],
                maxHeight,
                overflow: 'auto',
                '&:focus-within': {
                    borderColor: error ? 'error.main' : 'primary.main',
                    boxShadow: (theme) => `0 0 0 1px ${error ? theme.palette.error.main : theme.palette.primary.main}`
                },
                '& textarea': {outline: 'none'},
                ...TOKEN_COLORS_SX
            }}>
            <Box component="label" htmlFor={id} sx={VISUALLY_HIDDEN_SX}>{label}</Box>
            <Editor
                textareaId={id}
                value={value}
                onValueChange={onChange}
                onKeyDown={onKeyDown}
                highlight={highlight}
                placeholder={placeholder}
                padding={padding}
                disabled={disabled}
                tabSize={2}
                insertSpaces
                style={{
                    fontFamily: MONOSPACE_FONT,
                    fontSize: 13,
                    lineHeight: 1.65,
                    minHeight
                }}/>
        </Box>
    );
}

export function DlvYamlEditor(props) {
    return <DlvCodeEditor highlight={highlightYaml} minHeight={440} maxHeight="70vh" {...props}/>;
}
